import React, { useEffect, useState } from "react";
import {
  Breadcrumb,
  Row,
  Col,
  Card,
  Drawer,
  Descriptions,
  Anchor,
  Tag,
  Space,
  Button,
  Switch,
  Form,
  Input,
  Select,
  notification,
} from "antd";
import { Table } from "ant-table-extensions";
import http from "../../../helpers/http";
import helper from "../../../helpers/helper";
import config from "../../../config/config";
import moment from "moment";
function Index() {
  const [loading, setloading] = useState(false);
  const [drawerOpen, setdraweropen] = useState(false);
  const [datas, setDatas] = useState([]);
  const [data, setData] = useState({});
  const [user, setUser] = useState({});
  const [btnloading, setbtnloading] = useState(false);
  const [form] = Form.useForm();
  const moduleNamePural = "Application Form 2025";
  const base_url = config.api_url + "admin/2025/users"; //without trailing slash
  const image_url = config.api_url + "uploads/user-2025/"; //with trailing slash

  const breakthroughInnovationCategories = [
    { categoryName: "Raw Materials/Active Ingredients", parent: "technology" },
    { categoryName: "Formulation Technology", parent: "technology" },
    { categoryName: "Manufacturing Process", parent: "technology" },
    { categoryName: "Delivery Systems", parent: "technology" },
    { categoryName: "Packaging Innovation", parent: "technology" },
    { categoryName: "Testing/Analysis Methods", parent: "technology" },
    { categoryName: "Digital/AI Technology", parent: "technology" },
    { categoryName: "Biotechnology", parent: "technology" },
    { categoryName: "Sustainability Technology", parent: "technology" },
    { categoryName: "Skin Texture", parent: "beauty" },
    { categoryName: "Anti-Aging", parent: "beauty" },
    { categoryName: "Fermentation", parent: "beauty" },
    { categoryName: "Dark Circles", parent: "beauty" },
    { categoryName: "Inflammation", parent: "beauty" },
    {
      categoryName: "Specific Indian-based ingredients or sources",
      parent: "beauty",
    },
    { categoryName: "Hyperpigmentation", parent: "beauty" },
    { categoryName: "Acne", parent: "beauty" },
    { categoryName: "Anti-Pollution", parent: "beauty" },
    { categoryName: "Skin Physiology", parent: "beauty" },
    { categoryName: "Longevity", parent: "beauty" },
    { categoryName: "Product Delivery Systems", parent: "beauty" },
    { categoryName: "Other", parent: "beauty" },
  ];

  const { Option } = Select;

  const handleView = async (id) => {
    const { data } = await http.get(`${base_url}/${id}`);

    if (data) {
      setData(data);
      console.log(data);
      setdraweropen(true);
    }
  };

  function getSocialLink(platform, value) {
    if (!value) return null;
    if (value.startsWith("http")) return value;

    const username = value.startsWith("@") ? value.slice(1) : value;

    switch (platform) {
      case "instagram":
        return `https://www.instagram.com/${username}`;
      case "facebook":
        return `https://www.facebook.com/${username}`;
      case "youtube":
        return `https://www.youtube.com/@${username}`;
      case "tiktok":
        return `https://www.tiktok.com/@${username}`;
      case "linkedin":
        return `https://www.linkedin.com/in/${username}`;
      case "snapchat":
        return `https://www.snapchat.com/add/${username}`;
      default:
        return value;
    }
  }

  const handleDrawerClose = () => {
    setData({});
    setdraweropen(false);
  };

  const fetchDatas = async (status = "all", semifinalist = "all") => {
    setloading(true);
    const data = await http.get(
      `${base_url}?status=${status}&semifinalist=${semifinalist}`
    );

    if (data) {
      setDatas(data.data);
      console.log(data.data);
    }
    setloading(false);
  };

  useEffect(() => {
    fetchDatas();
    setUser(helper.getUser());
    console.log(helper.getUser());
  }, []);

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text, record) => {
        return `${record.first_name}  ${record.last_name}`;
      },
      sorter: (a, b) => a.first_name?.localeCompare(b.first_name),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      sorter: (a, b) => a.email?.localeCompare(b.email),
    },
    // {
    //   title: "Phone",
    //   dataIndex: "phone",
    //   key: "phone",
    //   render: (text, record) => {
    //     return `${record.country_code}${record.phone}`;
    //   },
    //   // sorter: (a, b) => a.phone?.localeCompare(b.phone),
    // },

    {
      title: "Category",
      dataIndex: "category",
      key: "category",
      render: (text, record) => {
        return record.breakthrough_background == "yes"
          ? "Breakthrough"
          : record.in_currently_market == "yes"
          ? "Grow"
          : record.in_currently_market == "no" &&
            record.breakthrough_background == "no"
          ? "Imagine"
          : "NA";
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text, record) => {
        return record.status == "registered" ? (
          <Tag color="red">{record.status}</Tag>
        ) : record.status == "completed" ? (
          <Tag color="green">{record.status}</Tag>
        ) : (
          <Tag color="orange">partially filled</Tag>
        );
      },
    },
    // {
    //   title: "Approved by Nykaa?",
    //   dataIndex: "is_nykaa_approved",
    //   key: "is_nykaa_approved",
    //   render: (text, record) => {
    //     return user.permission.includes("nykaa_approve") ? (
    //       <Space size="middle">
    //         <Switch
    //           checkedChildren="yes"
    //           unCheckedChildren="no"
    //           onChange={(value) => {
    //             handleStatus("is_nykaa_approved", value, record._id);
    //           }}
    //           defaultChecked={record.is_nykaa_approved}
    //         />
    //       </Space>
    //     ) : record.is_nykaa_approved ? (
    //       <Tag color="green">Yes</Tag>
    //     ) : (
    //       <Tag color="red">No</Tag>
    //     );
    //   },
    // },
    // {
    //   title: "Approved by Estee?",
    //   dataIndex: "is_estee_approved",
    //   key: "is_estee_approved",
    //   render: (text, record) => {
    //     return user.permission.includes("estee_approve") ? (
    //       <Space size="middle">
    //         <Switch
    //           checkedChildren="yes"
    //           unCheckedChildren="no"
    //           onChange={(value) => {
    //             handleStatus("is_estee_approved", value, record._id);
    //           }}
    //           defaultChecked={record.is_estee_approved}
    //         />
    //       </Space>
    //     ) : record.is_estee_approved ? (
    //       <Tag color="green">Yes</Tag>
    //     ) : (
    //       <Tag color="red">No</Tag>
    //     );
    //   },
    // },
    // {
    //   title: "Finalist?",
    //   dataIndex: "is_semifinalist",
    //   key: "is_semifinalist",
    //   render: (text, record) => {
    //     return user?.permission.includes("final_approve") ? (
    //       <Space size="middle">
    //         <Switch
    //           checkedChildren="yes"
    //           unCheckedChildren="no"
    //           onChange={(value) => {
    //             handleStatus("is_semifinalist", value, record._id);
    //           }}
    //           defaultChecked={record.is_semifinalist}
    //         />
    //       </Space>
    //     ) : record.is_semifinalist ? (
    //       <Tag color="green">Yes</Tag>
    //     ) : (
    //       <Tag color="red">No</Tag>
    //     );
    //   },
    // },
    {
      title: "Created At",
      render: (text, record) => {
        return helper.ISTDate(record.createdAt);
      },
      key: "createdAt",
      sorter: (a, b) => moment(a.createdAt).unix() - moment(b.createdAt).unix(),
    },
    {
      title: "Completed At",
      render: (text, record) => {
        return helper.ISTDate(record.updatedAt);
      },
      key: "updatedAt",
      sorter: (a, b) => moment(a.updatedAt).unix() - moment(b.updatedAt).unix(),
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <Space size="middle">
          <Button
            type="primary"
            onClick={() => {
              handleView(record._id);
            }}
          >
            View Detail
          </Button>
        </Space>
      ),
    },
  ];

  const fields = {
    // category: "Category",
    category: {
      header: "Category",
      formatter: (_fieldValue, record) => {
        return record.breakthrough_background == "yes"
          ? "Breakthrough"
          : record.in_currently_market == "yes"
          ? "Grow"
          : record.in_currently_market == "no" &&
            record.breakthrough_background == "no"
          ? "Imagine"
          : "NA";
      },
    },
    first_name: "First Name",

    last_name: "Last Name",
    email: {
      header: "Email",
      formatter: (_fieldValue, record) => {
        if (!record.email) return "";
        return `=HYPERLINK("mailto:${record.email}", "${record.email}")`;
      },
    },
    phone: {
      header: "Phone",
      formatter: (_fieldValue, record) => {
        return record.country_code + record.phone;
      },
    },
    title: "Title",
    comp_name: "Company Name",

    head_location: {
      header: "Country",
      formatter: (_fieldValue, record) => {
        return record.countryData[0]?.name;
      },
    },
    address1: "Address 1",
    address2: "Address 2",

    state: {
      header: "State",
      formatter: (_fieldValue, record) => {
        return record.stateData[0]?.name;
      },
    },

    city: {
      header: "City",
      formatter: (_fieldValue, record) => {
        return record.cityData[0]?.name;
      },
    },
    zip: "Zip",
    // company_phone: "Company Phone",
    is_university_student: "Are you a university student?",

    university_name: "University Name",
    // is_breakthrough_prize: "Is this a submission for the Breakthrough Prize?",
    company_website: {
      header: "Company Website",
      formatter: (_fieldValue, record) => {
        if (!record.company_website) return "";
        const url = record.company_website.startsWith("http")
          ? record.company_website
          : `https://${record.company_website}`;
        return `=HYPERLINK("${url}", "${record.company_website}")`;
      },
    },
    instagram: {
      header: "Instagram",
      formatter: (_fieldValue, record) => {
        if (!record.instagram) return "";
        const url = getSocialLink("instagram", record.instagram);
        return `=HYPERLINK("${url}", "${record.instagram}")`;
      },
    },
    facebook: {
      header: "Facebook",
      formatter: (_fieldValue, record) => {
        if (!record.facebook) return "";
        const url = getSocialLink("facebook", record.facebook);
        return `=HYPERLINK("${url}", "${record.facebook}")`;
      },
    },
    youtube: {
      header: "Youtube",
      formatter: (_fieldValue, record) => {
        if (!record.youtube) return "";
        const url = getSocialLink("youtube", record.youtube);
        return `=HYPERLINK("${url}", "${record.youtube}")`;
      },
    },
    tiktok: {
      header: "Tiktok",
      formatter: (_fieldValue, record) => {
        if (!record.tiktok) return "";
        const url = getSocialLink("tiktok", record.tiktok);
        return `=HYPERLINK("${url}", "${record.tiktok}")`;
      },
    },
    linkedin: {
      header: "Linkedin",
      formatter: (_fieldValue, record) => {
        if (!record.linkedin) return "";
        const url = getSocialLink("linkedin", record.linkedin);
        return `=HYPERLINK("${url}", "${record.linkedin}")`;
      },
    },
    snapchat: {
      header: "Snapchat",
      formatter: (_fieldValue, record) => {
        if (!record.snapchat) return "";
        const url = getSocialLink("snapchat", record.snapchat);
        return `=HYPERLINK("${url}", "${record.snapchat}")`;
      },
    },
    other_social: {
      header: "Other Social handle",
      formatter: (_fieldValue, record) => {
        if (!record.other_social) return "";
        const url = record.other_social.startsWith("http")
          ? record.other_social
          : `https://${record.other_social}`;
        return `=HYPERLINK("${url}", "${record.other_social}")`;
      },
    },
    buss_type:
      "Are you a Company/ Partnership/ Sole proprietorship/Pre-Launch Concept?",
    gst_no: "GST No",

    date_of_launch: {
      header: "Date Of Launch",
      formatter: (_fieldValue, record) => {
        return record.comp_launch_date
          ? `${record.comp_launch_date}-${record.comp_launch_month}-${record.comp_launch_year}`
          : "NA";
      },
    },
    female_founder: "Have a female founder",
    female_founder_full_name: "Female Founder Full Name",
    female_founder_full_title: "Female Founder Full Title",
    female_founder_addressing_womens_needs:
      "Addressing unmet needs or challenges faced by women consumers",
    female_founder_supporting_women:
      "Supporting or empowering women in beauty/community",
    female_founder_breakthrough_milestone:
      "Female founder's proudest milestone & leadership impact",
    emp_count: {
      header: "Number Of Employees",
      formatter: (_fieldValue, record) => {
        return record.emp_count ? "( " + record.emp_count + " )" : null;
      },
    },

    in_currently_market: "Is your company currently trading in-market?",

    buss_overview: {
      header:
        "Upload a one page overview of your business, idea, or innovation.",
      formatter: (_fieldValue, record) => {
        return `=HYPERLINK("${
          record.buss_overview ? image_url + record.buss_overview : ""
        }", "${record.buss_overview ? image_url + record.buss_overview : ""}")`;
      },
    },
    buss_video_link: {
      header: "One-page overview of your business, idea, or innovation.",
      formatter: (_fieldValue, record) => {
        return `=HYPERLINK("${record.buss_video_link}", "${record.buss_video_link}")`;
      },
    },

    selling_product_category: "In which product categories do you sell?",
    other_selling_product_category: "Other",
    target_age: "Age demographic target",
    other_target_age: "Other",
    elevator_pitch: "Please provide your company 'elevator pitch'",
    brand_exp_business: {
      header: "Beauty Frontiers business impact",
      formatter: (_fieldValue, record) => {
        return record.in_currently_market === "yes" ||
          record.breakthrough_background === "no"
          ? record.brand_exp || ""
          : "";
      },
    },
    brand_exp_innovation: {
      header: "Beauty Frontiers innovation impact",
      formatter: (_fieldValue, record) => {
        return record.in_currently_market === "no" &&
          record.breakthrough_background === "yes"
          ? record.brand_exp || ""
          : "";
      },
    },
    brand_desc: "Describe your brand and business",
    scientific_approach: "Innovation/scientific approach",
    innovation_scientific_gap: "Scientific/Innovation gap",
    consumer_insight_buss: "Breakthrough consumer insight market",
    consumer_insight: "Breakthrough consumer insight scientific approach",
    company_background: "Company background & experience",
    breakthrough_market: "Breakthrough market",
    sector_background: "Sector background",
    education_background_exp: "Education background & experience",
    other_education_background_exp: "Other",
    intellectual_property: "Intellectual property",
    intellectual_property_extra_info: "Extra info",
    technical_documentation: "Technical documentation",
    investment_categories: "Funding/Investment to date",
    other_investment_categories: "Other",
    commercial_potential: "Commercial potential",
    beauty_industry_desc: "Beauty industry impact",
    addressing_opp: "What market opportunity is your company addressing",
    breakthrough_innovation_categories: {
      header: "Which categories best describe your breakthrough innovation?",
      formatter: (_fieldValue, record) => {
        if (
          !record.breakthrough_innovation_categories ||
          record.breakthrough_innovation_categories.trim() === ""
        ) {
          return "";
        }
        const categories = record.breakthrough_innovation_categories
          .split(",")
          .map((cat) => cat.trim())
          .filter((cat) => cat);

        const techCats = categories.filter((cat) =>
          breakthroughInnovationCategories.find(
            (c) => c.categoryName === cat && c.parent === "technology"
          )
        );
        const beautyCats = categories.filter((cat) =>
          breakthroughInnovationCategories.find(
            (c) => c.categoryName === cat && c.parent === "beauty"
          )
        );

        let result = [];
        if (techCats.length > 0) {
          result.push(`Technology/Approach Categories: ${techCats.join(", ")}`);
        }
        if (beautyCats.length > 0) {
          result.push(
            `Beauty Application Categories: ${beautyCats.join(", ")}`
          );
        }
        return result.join(" | ");
      },
    },
    other_breakthrough_innovation_categories: "Other",
    current_breakthrough_innovation: "Current Innovation stage",
    company_leverage: "How company leverages technology",
    is_sustain_mission:
      "Do you have a sustainability or social impact mission?",
    mission: "What is your mission?",
    sustain_focus_category: "In which categories are you focusing?",
    other_sustain_focus_category: "Other",
    revenue_2022: "What were your 2024 revenues?",
    revenue_india: "How much of your company revenue comes from India?",
    distribution_channel: "What are your distribution channels?",
    other_distribution_channel: "Other",
    hear_source: "How did you hear about BEAUTY&YOU?",
    other_hear_source: "Other",
    applicable_reason: "Why is it applicable to Indian consumers?",
    innovation_sustainability:
      "Is your breakthrough innovation sustainable? If so, how?",
    traction_info:
      "Do you have any information around interest (pre-launch) or traction (in market) that you would like to share with us",
    investment_to_date: "Investment to date",
    market_win_reason: "Why will you win the market?",
    right_founder_reason:
      "Why are you the right founder to lead this next wave in beauty? Share what sets you apart and why your vision has the potential to break through and scale.",
    extra_info: "Anything else you'd like us to know",

    // addressing_ingredient:
    //   "What issue area or product process / technology does your active ingredient address?",
    // other_addressing_ingredient: "Other",

    // efficacy_evidence:
    //   "What is the evidence that demonstrates efficacy of your product",
    // company_background:
    //   "Describe your company/background and your experience in this sector ",
    // ingredient_market: "What is the market for your ingredient?",
    // applicable_reason: "Why is it applicable to Indian consumers?",
    // is_ingredient_sustain: "Is your ingredient considered sustainable?",
    // ingredient_sustain_reason:
    //   "please describe why it is considered sustainable?",

    // breakthrough_in_currently_market: "Are you currently in market?",

    // buss_overview_link: "overview of your business video link",

    // agree_to_email: {
    //   header: "Agree to receive Email",
    //   formatter: (_fieldValue, record) => {
    //     return record.agree_to_email ? "yes" : "no";
    //   },
    // },
    // agree_to_sms: {
    //   header: "Agree to receive SMS",
    //   formatter: (_fieldValue, record) => {
    //     return record.agree_to_sms ? "yes" : "no";
    //   },
    // },
    status: {
      header: "Status",
      formatter: (_fieldValue, record) => {
        return record.status == "registered"
          ? record.status
          : record.status == "completed"
          ? record.status
          : "partially filled";
      },
    },

    createdAt: {
      header: "Created At",
      formatter: (_fieldValue, record) => {
        return helper.ISTDate(record.createdAt);
      },
    },
    updatedAt: {
      header: "Completed At",
      formatter: (_fieldValue, record) => {
        return helper.ISTDate(record.updatedAt);
      },
    },
  };

  const handleSubmit = async (value) => {
    // let errors = await validate(value);

    // setFormError(errors);

    // if (Object.keys(errors).length) {
    //   return;
    // }

    setbtnloading(true);
    fetchDatas(value.status, "all");
    setbtnloading(false);
  };

  const handleStatus = async (key, value, id) => {
    const data = value ? 1 : 0;

    const result = await http.put(`${base_url}/status/${id}`, {
      [key]: data,
    });

    if (result) {
      notification["success"]({
        message: "Status Changed Successfully",
      });
    }
  };

  return (
    <div>
      <Breadcrumb style={{ margin: "16px 0" }}>
        <Breadcrumb.Item>Dashboard</Breadcrumb.Item>
        <Breadcrumb.Item>Leads</Breadcrumb.Item>
        <Breadcrumb.Item>{moduleNamePural}</Breadcrumb.Item>
      </Breadcrumb>
      <Row gutter={15}>
        <Col span={24}>
          <div className="site-card-border-less-wrapper">
            <Card title={moduleNamePural} bordered={false}>
              <Form layout="inline" form={form} onFinish={handleSubmit}>
                <Form.Item
                  label="Status:"
                  name="status"
                  // {...(formError.status && {
                  //   help: formError.status,
                  //   validateStatus: "error",
                  // })}
                  style={{ width: 200 }}
                >
                  <Select defaultValue="all">
                    <Option value="all">All</Option>
                    <Option value="registered">Registered</Option>
                    <Option value="partial">Partially Filled</Option>
                    <Option value="completed">Completed</Option>
                  </Select>
                </Form.Item>

                {/* <Form.Item
                  label="Finalist:"
                  name="semifinalist"
                 
                >
                  <Select defaultValue="all">
                    <Option value="all">All</Option>
                    <Option value="yes">Yes</Option>
                    <Option value="no">No</Option>
                  </Select>
                </Form.Item> */}
                <Form.Item>
                  <Button type="primary" htmlType="submit" loading={btnloading}>
                    Filter
                  </Button>
                </Form.Item>
              </Form>
            </Card>
          </div>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <div className="site-card-border-less-wrapper">
            <Card bordered={false}>
              <Table
                rowKey={(record) => record._id}
                columns={columns}
                dataSource={datas}
                loading={loading}
                exportableProps={
                  user?.permission?.includes("export")
                    ? {
                        showColumnPicker: false,
                        fields,
                        fileName: moduleNamePural,
                      }
                    : null
                }
              />
            </Card>

            <Drawer
              title="Lead Details"
              placement="right"
              onClose={handleDrawerClose}
              visible={drawerOpen}
              size="large"
              width={1000}
            >
              {data && (
                <>
                  <Descriptions
                    title="Basic Details"
                    bordered
                    column={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}
                    size="small"
                  >
                    <Descriptions.Item label="First Name">
                      {data.first_name || "NA"}
                    </Descriptions.Item>
                    <Descriptions.Item label="Last Name">
                      {data.last_name || "NA"}
                    </Descriptions.Item>
                    <Descriptions.Item label="Email">
                      {data.email ? (
                        <a
                          href={`mailto:${data.email}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {data.email}
                        </a>
                      ) : (
                        "NA"
                      )}
                    </Descriptions.Item>
                    <Descriptions.Item label="Phone">
                      {data.country_code}
                      {data.phone || "NA"}
                    </Descriptions.Item>
                    {/* <Descriptions.Item label="Agree to receive Email">
                      {data.agree_to_email ? "Yes" : "No"}
                    </Descriptions.Item>
                    <Descriptions.Item label="Agree to receive SMS">
                      {data.agree_to_sms ? "Yes" : "No"}
                    </Descriptions.Item> */}

                    <Descriptions.Item label="Title/Designation">
                      {data.title || "NA"}
                    </Descriptions.Item>
                    <Descriptions.Item label="Company Name">
                      {data.comp_name || "NA"}
                    </Descriptions.Item>
                    <Descriptions.Item label="Country">
                      {data.countryData?.name || "NA"}
                    </Descriptions.Item>
                    <Descriptions.Item label="Address 1">
                      {data.address1 || "NA"}
                    </Descriptions.Item>
                    <Descriptions.Item label="Address 2">
                      {data.address2 || "NA"}
                    </Descriptions.Item>
                    <Descriptions.Item label="State">
                      {data.stateData?.name || "NA"}
                    </Descriptions.Item>
                    <Descriptions.Item label="City">
                      {data.cityData?.name || "NA"}
                    </Descriptions.Item>
                    <Descriptions.Item label="Zip">
                      {data.zip || "NA"}
                    </Descriptions.Item>

                    <Descriptions.Item label="Are you a university student?">
                      {data.is_university_student || "NA"}
                    </Descriptions.Item>
                    <Descriptions.Item label="Please provide University Name">
                      {data.university_name || "NA"}
                    </Descriptions.Item>
                    {/* <Descriptions.Item label="Is this a submission for the Breakthrough Prize?  ">
                      {data.is_breakthrough_prize || "NA"}
                    </Descriptions.Item> */}
                    <Descriptions.Item label="Company website">
                      {data.company_website ? (
                        <a
                          href={
                            data.company_website.startsWith("http")
                              ? data.company_website
                              : `https://${data.company_website}`
                          }
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {data.company_website}
                        </a>
                      ) : (
                        "NA"
                      )}
                    </Descriptions.Item>
                    <Descriptions.Item label="Instagram">
                      {data.instagram ? (
                        <a
                          href={getSocialLink("instagram", data.instagram)}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {getSocialLink("instagram", data.instagram)}
                        </a>
                      ) : (
                        "NA"
                      )}
                    </Descriptions.Item>
                    <Descriptions.Item label="Facebook">
                      {data.facebook ? (
                        <a
                          href={getSocialLink("facebook", data.facebook)}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {getSocialLink("facebook", data.facebook)}
                        </a>
                      ) : (
                        "NA"
                      )}
                    </Descriptions.Item>
                    <Descriptions.Item label="Youtube">
                      {data.youtube ? (
                        <a
                          href={getSocialLink("youtube", data.youtube)}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {getSocialLink("youtube", data.youtube)}
                        </a>
                      ) : (
                        "NA"
                      )}
                    </Descriptions.Item>
                    <Descriptions.Item label="Tiktok">
                      {data.tiktok ? (
                        <a
                          href={getSocialLink("tiktok", data.tiktok)}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {getSocialLink("tiktok", data.tiktok)}
                        </a>
                      ) : (
                        "NA"
                      )}
                    </Descriptions.Item>
                    <Descriptions.Item label="Linkedin">
                      {data.linkedin ? (
                        <a
                          href={getSocialLink("linkedin", data.linkedin)}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {getSocialLink("linkedin", data.linkedin)}
                        </a>
                      ) : (
                        "NA"
                      )}
                    </Descriptions.Item>
                    <Descriptions.Item label="Snapchat">
                      {data.snapchat ? (
                        <a
                          href={getSocialLink("snapchat", data.snapchat)}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {getSocialLink("snapchat", data.snapchat)}
                        </a>
                      ) : (
                        "NA"
                      )}
                    </Descriptions.Item>
                    <Descriptions.Item label="Other Social handle">
                      {data.other_social ? (
                        <a
                          href={
                            data.other_social.startsWith("http")
                              ? data.other_social
                              : `https://${data.other_social}`
                          }
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {data.other_social}
                        </a>
                      ) : (
                        "NA"
                      )}
                    </Descriptions.Item>
                    <Descriptions.Item label="Are you a Company/ Partnership/ Sole proprietorship/Pre-Launch Concept?">
                      {data.buss_type || "NA"}
                    </Descriptions.Item>
                    <Descriptions.Item label="GST No">
                      {data.gst_no || "NA"}
                    </Descriptions.Item>
                    <Descriptions.Item label="Date of company launch">
                      {data.comp_launch_date
                        ? `${data.comp_launch_date}-${data.comp_launch_month}-${data.comp_launch_year}`
                        : "NA"}
                    </Descriptions.Item>
                    <Descriptions.Item label="Number of Employees">
                      {data.emp_count || "NA"}
                    </Descriptions.Item>
                    <Descriptions.Item label="Do you have a female founder as part of your team?">
                      {data.female_founder || "NA"}
                    </Descriptions.Item>
                    <Descriptions.Item label="Female Founder Full Name">
                      {data.female_founder_full_name || "NA"}
                    </Descriptions.Item>
                    <Descriptions.Item label="Female Founder Full Title">
                      {data.female_founder_full_title || "NA"}
                    </Descriptions.Item>
                    <Descriptions.Item label="How is your work specifically addressing unmet needs or challenges faced by women consumers in beauty, and what unique perspective do you bring as a female founder to solving these issues?">
                      {data.female_founder_addressing_womens_needs || "NA"}
                    </Descriptions.Item>
                    <Descriptions.Item
                      label="Describe how you are actively supporting or empowering other
                    women in the beauty industry or your broader
                    community—whether through mentorship, inclusive hiring,
                    supporting women-led supply chain partners, or creating
                    opportunities for female talent across product development,
                    retail, marketing, or manufacturing."
                    >
                      {data.female_founder_supporting_women || "NA"}
                    </Descriptions.Item>
                    <Descriptions.Item label="What breakthrough or milestone have you achieved as a female founder that you're most proud of, and how has this accomplishment demonstrated your leadership in pushing beauty frontiers forward?">
                      {data.female_founder_breakthrough_milestone || "NA"}
                    </Descriptions.Item>
                    <>
                      {data.is_creative_prize == "no" && (
                        <>
                          <Descriptions.Item label="Are you a Company/ Partnership/ Sole proprietorship/Pre-Launch Concept?">
                            {data.buss_type || "NA"}
                          </Descriptions.Item>
                          <Descriptions.Item label="GST No">
                            {data.gst_no || "NA"}
                          </Descriptions.Item>
                          <Descriptions.Item label="Date of company launch">
                            {/* {data.date_of_launch
                        ? helper.ISTDate(data.date_of_launch, "YYYY-MM-DD")
                        : "NA"} */}

                            {data.comp_launch_date
                              ? `${data.comp_launch_date}-${data.comp_launch_month}-${data.comp_launch_year}`
                              : "NA"}
                          </Descriptions.Item>
                          <Descriptions.Item label="Number of Employees">
                            {data.emp_count || "NA"}
                          </Descriptions.Item>
                          <Descriptions.Item label="Business reference name">
                            {data.buss_ref_name || "NA"}
                          </Descriptions.Item>
                          <Descriptions.Item label="Business reference designation">
                            {data.buss_ref_designation || "NA"}
                          </Descriptions.Item>
                          <Descriptions.Item label="Business reference email">
                            {data.buss_ref_email || "NA"}
                          </Descriptions.Item>
                          <Descriptions.Item label="Is your company currently trading in-market?">
                            {data.in_currently_market || "NA"}
                          </Descriptions.Item>
                        </>
                      )}
                    </>

                    <Descriptions.Item label="Created At">
                      {helper.ISTDate(data.createdAt)}
                    </Descriptions.Item>
                  </Descriptions>

                  {data?.in_currently_market == "yes" && (
                    <Descriptions
                      title="Grow"
                      bordered
                      column={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}
                      size="small"
                      style={{ marginTop: 20 }}
                    >
                      <Descriptions.Item label=" Please upload a one-page overview of your business.">
                        {data.buss_overview ? (
                          <a
                            href={image_url + data.buss_overview}
                            target="_blank"
                          >
                            View Overview
                          </a>
                        ) : (
                          "NA"
                        )}
                      </Descriptions.Item>

                      <Descriptions.Item label="Please upload a link to a 3-minute (max) video explaining your business">
                        {data.buss_video_link ? (
                          <a href={data.buss_video_link} target="_blank">
                            {data.buss_video_link}
                          </a>
                        ) : (
                          "NA"
                        )}
                      </Descriptions.Item>
                      <Descriptions.Item label="In which product categories do you sell or plan to sell?">
                        {data.selling_product_category || "NA"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Other">
                        {data.other_selling_product_category || "NA"}
                      </Descriptions.Item>
                      <Descriptions.Item label="What age demographic are you targetting?">
                        {data.target_age || "NA"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Other">
                        {data.other_target_age || "NA"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Please provide your company 'elevator pitch'">
                        {data.elevator_pitch || "NA"}
                      </Descriptions.Item>
                      <Descriptions.Item label="This year’s theme is Beauty Frontiers.  How does your business break new ground in beauty? Share the impact you aim to make—on consumers, the industry, or the market—and what sets your idea apart. How are you redefining what’s next for beauty?">
                        {data.brand_exp || "NA"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Describe your brand and business">
                        {data.brand_desc || "NA"}
                      </Descriptions.Item>
                      <Descriptions.Item label="What market opportunity is your company addressing?">
                        {data.addressing_opp || "NA"}
                      </Descriptions.Item>
                      <Descriptions.Item label="What breakthrough consumer insight is driving your business concept? What have you discovered about beauty consumers that others have missed, and how does this insight inform your brand vision, product concept, and market strategy?">
                        {data.consumer_insight_buss || "NA"}
                      </Descriptions.Item>
                      <Descriptions.Item label="How is your company leveraging technology—such as AI, AR/VR, gaming platforms, data science, or other digital tools—in creative or unexpected ways to develop, launch, or grow your brand? This could include innovations in product formulation, consumer engagement, personalization, content creation, or operations">
                        {data.company_leverage || "NA"}
                      </Descriptions.Item>
                      {/* <Descriptions.Item label="What is your mission?">
                        {data.mission || "NA"}
                      </Descriptions.Item> */}
                      <Descriptions.Item label="Do you have a sustainability or social impact mission?">
                        {data.is_sustain_mission || "NA"}
                      </Descriptions.Item>
                      <Descriptions.Item label="In which categories are you focusing?">
                        {data.sustain_focus_category || "NA"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Other">
                        {data.other_sustain_focus_category || "NA"}
                      </Descriptions.Item>
                      <Descriptions.Item label="What were your 2024 revenues?">
                        {data.revenue_2022 || "NA"}
                      </Descriptions.Item>
                      <Descriptions.Item label="How much of your company revenue comes from India?">
                        {data.revenue_india || "NA"}
                      </Descriptions.Item>
                      <Descriptions.Item label="What are your distribution channels?">
                        {data.distribution_channel || "NA"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Other">
                        {data.other_distribution_channel || "NA"}
                      </Descriptions.Item>
                      <Descriptions.Item label="How did you hear about BEAUTY&YOU?">
                        {data.hear_source || "NA"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Other">
                        {data.other_hear_source || "NA"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Do you have any information around interest (pre-launch) or traction (in market) that you would like to share with us?">
                        {data.traction_info || "NA"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Investment to date">
                        {data.investment_to_date || "NA"}
                      </Descriptions.Item>
                      <Descriptions.Item
                        label=" Why are you the right founder to lead this next wave in beauty?
                Share what sets you apart and why your vision has the potential
                to break through and scale."
                      >
                        {data.right_founder_reason || "NA"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Why will you win the market?">
                        {data.market_win_reason || "NA"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Anything else you’d like us to know">
                        {data.extra_info || "NA"}
                      </Descriptions.Item>
                    </Descriptions>
                  )}
                  {data?.in_currently_market == "no" &&
                    data?.breakthrough_background == "no" && (
                      <Descriptions
                        title="Imagine"
                        bordered
                        column={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}
                        size="small"
                        style={{ marginTop: 20 }}
                      >
                        <Descriptions.Item label="Please upload a one-page overview of your business idea.">
                          {data.buss_overview ? (
                            <a
                              href={image_url + data.buss_overview}
                              target="_blank"
                            >
                              View Overview
                            </a>
                          ) : (
                            "NA"
                          )}
                        </Descriptions.Item>

                        <Descriptions.Item label="Please upload a link to a 3-minute (max) video explaining your business idea">
                          {data.buss_video_link ? (
                            <a href={data.buss_video_link} target="_blank">
                              {data.buss_video_link}
                            </a>
                          ) : (
                            "NA"
                          )}
                        </Descriptions.Item>
                        <Descriptions.Item label="In which product categories do you sell or plan to sell?">
                          {data.selling_product_category || "NA"}
                        </Descriptions.Item>
                        <Descriptions.Item label="Other">
                          {data.other_selling_product_category || "NA"}
                        </Descriptions.Item>
                        <Descriptions.Item label="What age demographic are you targeting?">
                          {data.target_age || "NA"}
                        </Descriptions.Item>
                        <Descriptions.Item label="Other">
                          {data.other_target_age || "NA"}
                        </Descriptions.Item>
                        {/* <Descriptions.Item label="What age demographic are you targetting?">
                        {data.target_age || "NA"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Other">
                        {data.other_target_age || "NA"}
                      </Descriptions.Item> */}
                        <Descriptions.Item label=" Please provide your company 'elevator pitch'">
                          {data.elevator_pitch || "NA"}
                        </Descriptions.Item>
                        <Descriptions.Item label="This year’s theme is Beauty Frontiers. How does your business break new ground in beauty? Share the impact you aim to make—on consumers, the industry, or the market—and what sets your idea apart. How are you redefining what’s next for beauty?">
                          {data.brand_exp || "NA"}
                        </Descriptions.Item>
                        <Descriptions.Item label="Describe your brand and business">
                          {data.brand_desc || "NA"}
                        </Descriptions.Item>
                        <Descriptions.Item label="What breakthrough consumer insight is driving your business concept? What have you discovered about beauty consumers that others have missed, and how does this insight inform your brand vision, product concept, and market strategy?">
                          {data.consumer_insight_buss || "NA"}
                        </Descriptions.Item>
                        <Descriptions.Item
                          label="How is your company leveraging technology—such as AI, AR/VR,
                gaming platforms, data science, or other digital tools—in
                creative or unexpected ways to develop, launch, or grow your
                brand? This could include innovations in product formulation,
                consumer engagement, personalization, content creation, or
                operations."
                        >
                          {data.company_leverage || "NA"}
                        </Descriptions.Item>
                        <Descriptions.Item label="What is your company mission?">
                          {data.mission || "NA"}
                        </Descriptions.Item>
                        <Descriptions.Item label="Do you have a sustainability or social impact mission?">
                          {data.is_sustain_mission || "NA"}
                        </Descriptions.Item>
                        <Descriptions.Item label="If yes, in which categories are you focusing?">
                          {data.sustain_focus_category || "NA"}
                        </Descriptions.Item>
                        <Descriptions.Item label="Other">
                          {data.other_sustain_focus_category || "NA"}
                        </Descriptions.Item>
                        <Descriptions.Item label="What are your distribution channels? If you have not launched yet, what do you anticipate will be your distribution channels?">
                          {data.distribution_channel || "NA"}
                        </Descriptions.Item>
                        <Descriptions.Item label="Other">
                          {data.other_distribution_channel || "NA"}
                        </Descriptions.Item>
                        <Descriptions.Item label="How did you hear about BEAUTY&YOU?">
                          {data.hear_source || "NA"}
                        </Descriptions.Item>
                        <Descriptions.Item label="Other">
                          {data.other_hear_source || "NA"}
                        </Descriptions.Item>
                        <Descriptions.Item label="Do you have any information around interest (pre-launch) or traction (in market) that you would like to share with us e.g., revenue, LTV, pre-orders, or other interesting data points?">
                          {data.traction_info || "NA"}
                        </Descriptions.Item>
                        <Descriptions.Item label="Why are you the right founder to lead this next wave in beauty? Share what sets you apart and why your vision has the potential to break through and scale.">
                          {data.right_founder_reason || "NA"}
                        </Descriptions.Item>
                        <Descriptions.Item label="Why will you win the market?">
                          {data.market_win_reason || "NA"}
                        </Descriptions.Item>
                        {/* <Descriptions.Item label="What were your 2022 revenues?">
                      {data.revenue_2022 || "NA"}
                    </Descriptions.Item>
                    <Descriptions.Item label="How much of your company revenue comes from India?">
                      {data.revenue_india || "NA"}
                    </Descriptions.Item> */}
                        <Descriptions.Item label="Anything else you’d like us to know">
                          {data.extra_info || "NA"}
                        </Descriptions.Item>
                      </Descriptions>
                    )}

                  {data?.in_currently_market == "no" &&
                    data?.breakthrough_background == "yes" && (
                      <Descriptions
                        title="Breakthrough Innovation"
                        bordered
                        column={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}
                        size="small"
                        style={{ marginTop: 20 }}
                      >
                        <Descriptions.Item label="Please upload a one-page overview of your breakthrough innovation.">
                          {data.buss_overview ? (
                            <a
                              href={image_url + data.buss_overview}
                              target="_blank"
                            >
                              View Overview
                            </a>
                          ) : (
                            "NA"
                          )}
                        </Descriptions.Item>

                        <Descriptions.Item label="Please upload a link to a 3-minute (max) video explaining your breakthrough innovation.">
                          {data.buss_video_link ? (
                            <a href={data.buss_video_link} target="_blank">
                              {data.buss_video_link}
                            </a>
                          ) : (
                            "NA"
                          )}
                        </Descriptions.Item>
                        <Descriptions.Item label="Which categories best describe your breakthrough innovation?">
                          {data.breakthrough_innovation_categories &&
                          data.breakthrough_innovation_categories.trim() !== ""
                            ? (() => {
                                const categories =
                                  data.breakthrough_innovation_categories
                                    .split(",")
                                    .map((cat) => cat.trim())
                                    .filter((cat) => cat); // remove empty strings

                                const techCats = categories.filter((cat) =>
                                  breakthroughInnovationCategories.find(
                                    (c) =>
                                      c.categoryName === cat &&
                                      c.parent === "technology"
                                  )
                                );
                                const beautyCats = categories.filter((cat) =>
                                  breakthroughInnovationCategories.find(
                                    (c) =>
                                      c.categoryName === cat &&
                                      c.parent === "beauty"
                                  )
                                );

                                return (
                                  <>
                                    {techCats.length > 0 && (
                                      <>
                                        <b>Technology/Approach Categories:</b>
                                        <ul style={{ marginBottom: 8 }}>
                                          {techCats.map((cat) => (
                                            <li key={cat}>{cat}</li>
                                          ))}
                                        </ul>
                                      </>
                                    )}
                                    {beautyCats.length > 0 && (
                                      <>
                                        <b>Beauty Application Categories:</b>
                                        <ul>
                                          {beautyCats.map((cat) => (
                                            <li key={cat}>{cat}</li>
                                          ))}
                                        </ul>
                                      </>
                                    )}
                                  </>
                                );
                              })()
                            : "NA"}
                        </Descriptions.Item>
                        <Descriptions.Item label="Other">
                          {data.other_breakthrough_innovation_categories ||
                            "NA"}
                        </Descriptions.Item>
                        <Descriptions.Item label="What stage is your innovation currently at?">
                          {data.current_breakthrough_innovation || "NA"}
                        </Descriptions.Item>
                        {/* <Descriptions.Item label="What issue area or product process / technology does your active ingredient address?">
                          {data.addressing_ingredient || "NA"}
                        </Descriptions.Item>
                        <Descriptions.Item label="Other">
                          {data.other_addressing_ingredient || "NA"}
                        </Descriptions.Item> */}
                        <Descriptions.Item label="Please provide your innovation 'elevator pitch'">
                          {data.elevator_pitch || "NA"}
                        </Descriptions.Item>
                        <Descriptions.Item label="This year’s theme is Beauty Frontiers. How does your innovation break new ground in beauty? Share the impact you aim to make—on consumers, the industry, or the market—and what sets your innovation apart. How are you redefining what’s next for the category?">
                          {data.brand_exp || "NA"}
                        </Descriptions.Item>
                        <Descriptions.Item label="Describe your innovation and scientific approach">
                          {data.scientific_approach || "NA"}
                        </Descriptions.Item>
                        <Descriptions.Item label="What scientific or technological gap in the beauty industry is your innovation addressing">
                          {data.innovation_scientific_gap || "NA"}
                        </Descriptions.Item>
                        <Descriptions.Item label="What breakthrough consumer insight is driving your innovation? What have you discovered about beauty consumers' needs, behaviors, or desires that others have missed, and how does this insight inform your scientific approach? ">
                          {data.consumer_insight || "NA"}
                        </Descriptions.Item>
                        <Descriptions.Item
                          label="How is your company leveraging technology—such as AI, AR/VR,
                gaming platforms, data science, or other digital tools—in
                creative or unexpected ways to develop, launch, or grow your
                brand? This could include innovations in product formulation,
                consumer engagement, personalization, content creation, or
                operations."
                        >
                          {data.company_leverage || "NA"}
                        </Descriptions.Item>
                        <Descriptions.Item label="Describe your company background and your experience in the sector">
                          {data.company_background || "NA"}
                        </Descriptions.Item>
                        <Descriptions.Item label="What is the market for your breakthrough? ">
                          {data.breakthrough_market || "NA"}
                        </Descriptions.Item>
                        <Descriptions.Item label="Why is it applicable to Indian consumers?">
                          {data.applicable_reason || "NA"}
                        </Descriptions.Item>
                        {/* <Descriptions.Item label="What market opportunity is your company addressing">
                      {data.addressing_opp || "NA"}
                    </Descriptions.Item> */}
                        <Descriptions.Item label="Is your breakthrough innovation sustainable? If so, how?">
                          {data.innovation_sustainability || "NA"}
                        </Descriptions.Item>
                        <Descriptions.Item label="Describe your background in the sector">
                          {data.sector_background || "NA"}
                        </Descriptions.Item>

                        <Descriptions.Item label="Do you have a sustainability or social impact mission in your innovation?">
                          {data.is_sustain_mission || "NA"}
                        </Descriptions.Item>
                        <Descriptions.Item label="If yes, in which categories are you focusing">
                          {data.sustain_focus_category || "NA"}
                        </Descriptions.Item>
                        <Descriptions.Item label="Other">
                          {data.other_sustain_focus_category || "NA"}
                        </Descriptions.Item>
                        <Descriptions.Item label="What is your educational background and relevant experience?">
                          {data.education_background_exp || "NA"}
                        </Descriptions.Item>
                        <Descriptions.Item label="Other">
                          {data.other_education_background_exp || "NA"}
                        </Descriptions.Item>
                        <Descriptions.Item label="Do you have any intellectual property (patents, patent applications, trade secrets) related to your innovation?">
                          {data.intellectual_property || "NA"}
                        </Descriptions.Item>
                        <Descriptions.Item label="Extra Info">
                          {data.intellectual_property_extra_info || "NA"}
                        </Descriptions.Item>
                        <Descriptions.Item label="Do you have any scientific publications, research papers, or technical documentation that you would like to share with us? Please provide details or links">
                          {data.technical_documentation || "NA"}
                        </Descriptions.Item>
                        <Descriptions.Item label="Funding/Investment to date">
                          {data.investment_categories || "NA"}
                        </Descriptions.Item>
                        <Descriptions.Item label="Other">
                          {data.other_investment_categories || "NA"}
                        </Descriptions.Item>
                        <Descriptions.Item label="What is the commercial potential of your innovation and how do you plan to bring it to market?">
                          {data.commercial_potential || "NA"}
                        </Descriptions.Item>
                        <Descriptions.Item label="Why will your innovation push the frontiers and transform the beauty industry?">
                          {data.beauty_industry_desc || "NA"}
                        </Descriptions.Item>
                        <Descriptions.Item label="Why are you the right founder to lead this next wave in beauty? Share what sets you apart and why your vision has the potential to break through and scale.">
                          {data.right_founder_reason || "NA"}
                        </Descriptions.Item>
                        <Descriptions.Item label="Why will you win the market?">
                          {data.market_win_reason || "NA"}
                        </Descriptions.Item>
                        {/* <Descriptions.Item label="What were your 2022 revenues?">
                      {data.revenue_2022 || "NA"}
                    </Descriptions.Item>
                    <Descriptions.Item label="How much of your company revenue comes from India?">
                      {data.revenue_india || "NA"}
                    </Descriptions.Item> */}
                        <Descriptions.Item label="Anything else you'd like us to know about your breakthrough innovation">
                          {data.extra_info || "NA"}
                        </Descriptions.Item>
                      </Descriptions>
                    )}
                </>
              )}
            </Drawer>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default Index;
